import { render, staticRenderFns } from "./DailyReports2.vue?vue&type=template&id=a771f36a&scoped=true"
import script from "./DailyReports2.vue?vue&type=script&lang=js"
export * from "./DailyReports2.vue?vue&type=script&lang=js"
import style0 from "./DailyReports2.vue?vue&type=style&index=0&id=a771f36a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a771f36a",
  null
  
)

export default component.exports